/**
 * lib-core
 *
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ItemRegistry } from "@adapptio/lib-shared";
import { TGenericFunctionDefinition } from "@adapptio/lib-blueprint";

/**
 * Function Definition Registry
 */
export type IFunctionDefRegistry = ItemRegistry<TGenericFunctionDefinition>;

export class FunctionDefRegistry extends ItemRegistry<TGenericFunctionDefinition> {}
